/* Dansk katalog for locale-customers-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'sup.archiveBody': 'Vil du flytte {name} til arkivet? Leverandøren skjules fra aktive leverandørlister, men fakturaer, betalinger og historik bevares. Du kan åbne leverandøren igen senere.',
  'cust.title': 'Kunder',
  'cust.subtitle': 'Alle dine kunder ét sted',
  'cust.searchPh': 'Søg på kunde eller beløb',
  'cust.titleHelp': 'Dit kunderegister — alle kunder med kontaktoplysninger, udestående og samlet salg. Tryk på en kunde for at se opfølgning og fakturaer.',
  'cust.searchHelp': 'Søg i kunderne på navn, e-mail, samlet salg eller udestående beløb.',
  'cust.uploadHelp': 'Importér kunder fra en fil.',
  'cust.downloadHelp': 'Download kundelisten som CSV eller Excel.',
  'cust.addHelp': 'Tilføj en ny kunde med kontaktoplysninger og opfølgningsstatus.',
  'cust.filterHelp': 'Filtrér kunderne på status (aktiv, emne, tilbud sendt, på pause), om de har udestående, og om arkiverede skal vises.',
  'cust.listHelpTitle': 'Kundelisten',
  'cust.listHelp': 'Hver række er én kunde med kundenr., org.nr., e-mail, telefon, udestående og samlet salg. Tryk på en række for at åbne kunden.',
  'cust.filterOther': 'Andet',
  'cust.filterWithOutstanding': 'Kun med udestående',
  'cust.filterShowArchive': 'Vis arkiv',
  'cust.archived': 'Arkiveret',
  'cust.followUpInline': 'Opfølgning {date}',
  'cust.col.customer': 'Kunde',
  'cust.col.number': 'Kundenr.',
  'cust.col.org': 'Org.nr.',
  'cust.col.email': 'E-mail',
  'cust.col.phone': 'Telefon',
  'cust.col.outstanding': 'Udestående',
  'cust.col.totalSales': 'Samlet salg',
  'cust.outstandingInline': 'Udestående {amount}',
  'cust.balance.customerOwes': 'Kunden skylder dig {amount}',
  'cust.balance.youOwe': 'Du skylder kunden {amount}',
  'cust.balance.settled': 'Afstemt',
  'cust.followUp': 'Opfølgning',
  'cust.followUpHelp': 'Status, næste opfølgningsdato, noter og seneste aktiviteter for kunden. Brug chatknappen til at logge dialog og lave tilbud.',
  'cust.dialogTitle': 'Kundedialog',
  'cust.dialogHelp': 'Åbn en samtale med kunden — log beskeder, og byg et tilbudsgrundlag, du kan lave om til et tilbud.',
  'cust.openChat': 'Åbn chat',
  'cust.startChat': 'Start chat',
  'cust.nextFollowUp': 'Næste opfølgning',
  'cust.noFollowUpDate': 'Ingen dato angivet',
  'cust.status': 'Status',
  'cust.salesTitle': 'Salg til kunden',
  'cust.salesHelp': 'Alle fakturaer og kreditnotaer for kunden. Filtrér på alle, ikke betalt eller betalt — og åbn en faktura direkte med »Åbn«.',
  'cust.salesAll': 'Alle',
  'cust.salesUnpaid': 'Ikke betalt',
  'cust.salesPaid': 'Betalt',
  'cust.salesTotal': 'I alt',
  'cust.noSalesMatch': 'Intet salg passede til filteret.',
  'cust.creditNote': 'Kreditnota',
  'cust.invoice': 'Faktura',
  'cust.dueOn': 'Forfalder {date}',
  'cust.open': 'Åbn',
  'cust.pageRange': '{from}-{to} af {total}',
  'cust.prev': 'Forrige',
  'cust.next': 'Næste',
  'cust.act.newInvoice': 'Ny faktura',
  'cust.act.newInvoiceHelp': 'Start en ny faktura med denne kunde allerede valgt.',
  'cust.act.edit': 'Redigér',
  'cust.act.editHelp': 'Ret kundens kontaktoplysninger, status og opfølgning.',
  'cust.act.merge': 'Flet',
  'cust.act.mergeHelp': 'Flet to kunder, der er registreret dobbelt — salg og udestående samles på én kunde.',
  'cust.act.archive': 'Flyt til arkiv',
  'cust.act.archiveHelp': 'Skjul kunden fra aktive lister. Fakturaer, betalinger og historik bevares.',
  'cust.act.menu': 'Handling',
  'cust.archiveTitle': 'Flyt til arkiv?',
  'cust.archiveBody': 'Vil du flytte {name} til arkivet? Kunden skjules fra aktive kundelister, men fakturaer, betalinger og historik bevares.',
  'cust.archiveStillUsed': 'Kunden bruges stadig andre steder',
  'cust.archiveGroup': '{n} kundegruppe',
  'cust.archiveGroups': '{n} kundegrupper',
  'cust.archiveSubscription': '{n} abonnement',
  'cust.archiveSubscriptions': '{n} abonnementer',
  'cust.archiveAnd': ' og ',
  'cust.merge.title': 'Flet kunder',
  'cust.merge.keep': 'Bevares',
  'cust.merge.remove': 'Flettes og fjernes',
  'cust.merge.swap': 'Skift, hvilken kunde der bevares',
  'cust.merge.after': 'Efter fletning',
  'cust.merge.name': 'Kundenavn',
  'cust.merge.totalSales': 'Samlet salg',
  'cust.merge.notConnected': 'Fletning er ikke koblet til backend endnu.',
  'cust.merge.done': 'Kunderne blev flettet',
  'cust.merge.failed': 'Kunderne kunne ikke flettes.',
  'cust.form.name': 'Kundenavn',
  'cust.form.namePh': 'F.eks. Eksempel AS',
  'cust.form.orgOptional': 'Org.nummer (valgfrit)',
  'cust.form.org': 'Org.nummer',
  'cust.form.address': 'Adresse',
  'cust.form.addressPh': 'Gadeadresse',
  'cust.form.zip': 'Postnr.',
  'cust.form.city': 'By',
  'cust.form.cityPh': 'By',
  'cust.form.crm': 'Kundestatus',
  'cust.form.nextLabel': 'Næste: {date}',
  'cust.form.noFollowUp': 'Ingen opfølgning',
  'cust.form.dupTitle': 'Dette findes allerede på en anden kunde',
  'cust.form.dupName': '{names} har samme navn.',
  'cust.form.dupOrg': '{names} har samme organisationsnummer.',
  'cust.form.dupEmail': '{names} har samme e-mailadresse.',
  'cust.form.dupPhone': '{names} har samme telefonnummer.',
  'cust.form.dupUnnamed': 'En kunde uden navn',
  'cust.form.dupBody': 'Kunden gemmes som normalt. Er det den samme kunde, kan du flette de to fra kundekortet i listen.',
  'cust.form.contacts': 'Kontaktpersoner',
  'cust.form.contactsSub': 'Kan vælges som modtager, når du sender faktura, tilbud eller kvittering.',
  'cust.form.addContact': 'Tilføj kontaktperson',
  'cust.form.editContact': 'Redigér kontaktperson',
  'cust.form.contactFallback': 'Kontaktperson {n}',
  'cust.form.removeContact': 'Fjern kontaktperson',
  'cust.form.contactTitle': 'Kontaktperson',
  'cust.form.newTitle': 'Ny kunde',
  'cust.form.editTitle': 'Redigér kunde',
  'cust.form.saveContact': 'Gem',
  'cust.form.contactName': 'Navn',
  'cust.form.contactNamePh': 'F.eks. Mette Hansen',
  'cust.form.contactRole': 'Rolle',
  'cust.form.contactRolePh': 'F.eks. Regnskab',
  'cust.form.defaultRef': 'Fast fakturareference',
  'cust.form.defaultRefPh': 'F.eks. projektnummer, indkøbsordre eller afdeling',
  'cust.form.creditLimit': 'Kreditgrænse',
  'cust.form.creditLimitHint': 'Bruges i afstemningen til at måle kundens åbne saldo mod virksomhedens egen kreditpolitik. Ingen grænse spærrer fakturering.',
  'cust.form.creditLimitPh': 'F.eks. 60000',
  'cust.form.note': 'Kundenote',
  'cust.form.notePh': 'Note om kunden',
  'cust.form.activity': 'Tilføj aktivitetsnote',
  'cust.form.activityPh': 'Ringede til kunden, sendte prisopdatering…',
  'cust.form.update': 'Opdatér kunde',
  'cust.form.save': 'Gem kunde',
  'cust.crm.prospect': 'Emne',
  'cust.crm.quoteSent': 'Tilbud sendt',
  'cust.crm.active': 'Aktiv kunde',
  'cust.crm.pause': 'På pause',
  'cust.chat.scope.all': 'Hele samtalen',
  'cust.chat.scope.to': 'Til kunde',
  'cust.chat.scope.from': 'Fra kunde',
  'cust.chat.scope.internal': 'Interne noter',
  'cust.chat.helpAll': 'Du ser nu hele samtalen.',
  'cust.chat.helpTo': 'Du ser nu beskeder, du har sendt.',
  'cust.chat.helpFrom': 'Du ser nu beskeder fra kunden.',
  'cust.chat.helpInternal': 'Dette er dine interne noter i dialogen.',
  'cust.chat.threadsHelpTitle': 'Samtaler',
  'cust.chat.threadsHelp': 'Hver kunde kan have flere samtaler. Skift mellem dem her, eller start en ny dialog for en ny henvendelse.',
  'cust.chat.conversation': 'Samtale',
  'cust.chat.filterTitle': 'Filtrér samtalen',
  'cust.chat.filterHelp': 'Vælg, hvad du vil se i vinduet nedenfor: hele samtalen, beskeder, du har sendt, beskeder fra kunden eller interne noter.',
  'cust.chat.windowTitle': 'Samtalevindue',
  'cust.chat.windowHelp': 'Beskederne i dialogen. Det, du sender, vises til højre, kundens beskeder og interne noter til venstre. Træk i den nederste kant for at gøre vinduet større.',
  'cust.chat.internal': 'Internt',
  'cust.chat.newInternalTitle': 'Ny intern note',
  'cust.chat.saveInDialog': 'Gem i dialog',
  'cust.chat.saveMessage': 'Gem besked',
  'cust.chat.sendMessage': 'Send besked',
  'cust.chat.newTitle': 'Ny besked',
  'cust.chat.newHelp': 'Skriv et svar til kunden, indsæt en besked, du har modtaget, eller notér noget internt. Det valgte samtalefilter styrer, om dette sendes til kunden, gemmes som kundebesked eller gemmes som intern note.',
  'cust.chat.draftPh': 'Skriv svar, indsæt kundebesked, eller notér, hvad I blev enige om...',
  'cust.chat.newDialog': 'Ny dialog',
  'cust.chat.quoteTitle': 'Tilbudsgrundlag',
  'cust.chat.quoteHelp': 'Tilføj de produkter og priser, I blev enige om i samtalen. Tryk på Lav tilbud for at lave det om til en tilbudskladde med kunden allerede udfyldt.',
  'cust.chat.findProduct': 'Find produkt/pris',
  'cust.chat.productPh': 'Søg produktnavn...',
  'cust.chat.dragToMessage': 'Træk til beskeden',
  'cust.chat.dragTotal': 'Træk totalen til beskeden',
  'cust.chat.dragBasis': 'Træk hele tilbudsgrundlaget til beskeden',
  'cust.chat.quoteBasis': 'Hele grundlaget',
  'cust.chat.remove': 'Fjern',
  'cust.chat.total': 'I alt',
  'cust.chat.makeQuote': 'Lav tilbud',
  'cust.toast.updated': 'Kunde opdateret',
  'cust.toast.saved': 'Kunde gemt',
  'cust.toast.saveFailed': 'Kunne ikke gemme kunden.',
  'cust.toast.archived': 'Kunde flyttet til arkiv',
  'cust.toast.archiveFailed': 'Kunne ikke arkivere kunden.',
  'cust.toast.nothingToExport': 'Ingen kunder at eksportere',
  'cust.toast.exportFailed': 'Kunne ikke eksportere kundelisten.',
  'cust.toast.exported': 'Kundeliste downloadet',
  'cust.toast.noLedgerRows': 'Ingen debitorlinjer at eksportere',
  'cust.toast.ledgerExportFailed': 'Kunne ikke eksportere debitorkartoteket.',
  'cust.toast.ledgerExported': 'Debitorkartotek downloadet',
  'cust.toast.wrongFormat': 'Brug CSV eller XLSX med Plummes kundeskabelon.',
  'cust.toast.noneInFile': 'Fandt ingen kunder i filen.',
  'cust.toast.imported': '{n} kunder importeret',
  'cust.toast.importFailed': 'Kunne ikke importere kunder.',
  'cust.error.xlsxImport': 'XLSX-import er ikke tilgængelig endnu.',
  'cust.error.xlsxExport': 'Excel-eksport er ikke tilgængelig endnu.',
  'cust.export.number': 'Kundenr.',
  'cust.export.name': 'Navn',
  'cust.export.org': 'Org.nr.',
  'cust.export.email': 'E-mail',
  'cust.export.phone': 'Telefon',
  'cust.export.address': 'Adresse',
  'cust.export.zip': 'Postnr.',
  'cust.export.city': 'By',
  'cust.export.status': 'Status',
  'cust.export.followUp': 'Næste opfølgning',
  'cust.export.defaultRef': 'Fast fakturareference',
  'cust.export.note': 'Notat',
  'cust.ledger.code': 'Kode',
  'cust.ledger.date': 'Dato',
  'cust.ledger.doc': 'Bilagsnr./fakturanr.',
  'cust.ledger.type': 'Type',
  'cust.ledger.due': 'Forfald',
  'cust.ledger.debit': 'Debet',
  'cust.ledger.credit': 'Kredit',
  'cust.ledger.balance': 'Saldo efter linje',
  'cust.ledger.paid': 'Betalt',
  'cust.ledger.remaining': 'Resterende',
  'cust.ledger.partial': 'Delvist betalt',
  'cust.ledger.unpaid': 'Ikke betalt',
  'cust.ledger.posted': 'Bogført',
  'cust.ledger.refund': 'Tilbagebetaling til kunde',
  'cust.ledger.payment': 'Kundeindbetaling',
  'cust.ledger.creditOverpayment': 'Kredit / overbetaling',
  'cust.ledger.empty': 'Ingen debitorlinjer endnu.',
  'cust.import': 'Importér',
  'cust.importFrom': 'Importér fra',
  'cust.ledgerShort': 'Debitorer',
  'cust.ledger.sheet': 'Debitorkartotek',
  'cust.sheet.customers': 'Kunder',
});
